module.exports = __webpack_public_path__ + "static/media/uni-cc-03.d75586ec.png";